import { Injectable } from '@angular/core';
import { NGXSelectMayConfigs, NGXSelectMayRow } from './ngx-selectbox-may-configs';

@Injectable({
  providedIn: 'root'
})
export class NgxSelectboxMayService {

  constructor() { }

  createDropdownRows(items:any[], configs:NGXSelectMayConfigs):Array<NGXSelectMayRow>{
    let arr = [];
    items.forEach(element => {
      let row = new NGXSelectMayRow(false, element);
      row.setKey(configs.valueField ? element[configs.valueField] : element);
      row.setLabel(configs.labelField ? element[configs.labelField] : element);
      arr.push(row);
    });
    return arr;
  }

  reconfigureDropdownRowLabelsAndValues(allRows:Array<NGXSelectMayRow>, configs:NGXSelectMayConfigs){
    allRows.forEach(element => {
      element.setKey(configs.valueField ? element.data[configs.valueField] : element.data);
      element.setLabel(configs.labelField ? element.data[configs.labelField] : element.data);
    });
  }


  createDropdownLabel(configs:NGXSelectMayConfigs, selectedRows:Array<NGXSelectMayRow>){
    //Check is configured to select multiple choices
    if(configs.isMultiSelect){

      if(selectedRows.length > 1){
        return NGXSelectMayConfigs.MULTI_SELECTED_LABEL.replace("#COUNT", selectedRows.length.toString()).replace("#ITEMS", "Items");
      }else if(selectedRows.length == 1){
        return NGXSelectMayConfigs.MULTI_SELECTED_LABEL.replace("#COUNT", selectedRows.length.toString()).replace("#ITEMS", "Item");
      }else{
        return NGXSelectMayConfigs.MULTI_SELECTED_LABEL.replace("#COUNT", selectedRows.length.toString()).replace("#ITEMS", "Items");
      }

    }else{
      return selectedRows.length > 0 ? selectedRows[0].label : "";
    }
  }

  setSelectedItems(configs:NGXSelectMayConfigs, selectedRows:Array<NGXSelectMayRow>,allRows:Array<NGXSelectMayRow>, row:NGXSelectMayRow){
    //Check is configured to select multiple choices
    if(configs.isMultiSelect){
      
    }else{
      if(!row.isSelected){
        this.unselectAllSelectedRows(allRows);
        row.isSelected = true;
        selectedRows = [];
        selectedRows.push(row);
      }
    }
    return selectedRows;
  }

  unselectAllSelectedRows(allRows:Array<NGXSelectMayRow>){
    allRows.forEach(r => {
      r.isSelected = false;
    });
  }

  selectItemByValue(allRows:Array<NGXSelectMayRow>, value:any){
    let filteredVal = allRows.filter(r => r.value === value);
    if(filteredVal.length > 0) filteredVal[0].isSelected = true;
    return filteredVal;
  }

  selectItemsByValue(allRows:Array<NGXSelectMayRow>, values:Array<any>){
    let a = [];
    values.forEach(v => {
      let filteredVal = allRows.filter(r => r.value === v);
      if(filteredVal.length > 0) filteredVal[0].isSelected = true; a.push(filteredVal[0]);
    })
    return a;
  }
}
